<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <div
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        :class="{ collapse: collapse }"
      >
        <img src="../../assets/log/logo_small.png" class="sidebar-logo small" />
      </div>
      <div v-else key="expand" class="sidebar-logo-link">
        <img src="../../assets/log/logo_big.png" class="sidebar-logo big" />
        <span class="sidebar-title">{{ title }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      title: "商管平台",
    };
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 70px;
  line-height: 52px;
  background: #232221;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    padding-top: 15px;
    padding-left: 10px;
    display: flex;
    &.collapse {
      padding-left: 0px;
    }
    & .sidebar-logo {
      vertical-align: middle;
      margin-right: 12px;
      margin-left: 10px;
      &.small {
        width: 32px;
        height: 32px;
      }
      &.big {
        width: 42px;
        height: 42px;
      }
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 21px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
